(function($){
    $('#ms-home-search').on('click', function(e){
        e.preventDefault();
        $('#with-button-column .apply-filters__button').click();
    });

    $(document).ready(function(){
        $('#fix-prices .jet-checkboxes-list__label').each(function(){
            var txt = $(this).html();
            txt = txt.replace('do 0 zł — ', '');
            $(this).html(txt);
        })
    })
})(jQuery)